<section class="lead-gestor" aria-label="Lead atendido pela Mia Gestor" [attr.aria-busy]="carregando">
  <div class="esqueleto" *ngIf="!dados && carregando" aria-hidden="true">
    <div class="cabeca"><span class="avatar avatar--vazio"></span><div><i class="barra barra--larga"></i><i class="barra"></i></div></div>
    <i class="bloco"></i>
  </div>

  <ng-container *ngIf="!dados && !carregando && erro">
    <p class="faixa faixa--erro" role="alert">{{ erro }}</p>
    <button type="button" class="largo" (click)="carregue()"><i class="fas fa-sync-alt" aria-hidden="true"></i>Tentar de novo</button>
  </ng-container>

  <ng-container *ngIf="dados?.gestor">
    <header class="cabeca">
      <span class="avatar" aria-hidden="true">{{ inicial }}</span>
      <div class="identidade">
        <h3>{{ dados.lead?.nome || nome || 'Lead' }}</h3>
        <span class="num">{{ telefoneFormatado }}<ng-container *ngIf="dados.lead?.empresa"> · {{ dados.lead.empresa }}</ng-container></span>
      </div>
      <button type="button" class="icone-botao" (click)="carregue()" [disabled]="carregando" title="Atualizar" aria-label="Atualizar">
        <i class="fas fa-sync-alt" [class.girando]="carregando" aria-hidden="true"></i>
      </button>
    </header>

    <p class="canal">
      <i class="fas fa-robot" aria-hidden="true"></i>
      <span>Mia Gestor no {{ formateTelefone(dados.numero?.telefone) }}</span>
      <span class="pilula" *ngIf="dados.numero?.modoTeste" title="Só telefones da lista de teste são atendidos">Modo teste</span>
    </p>

    <div class="situacao situacao--{{ situacao.tom }}" role="status">
      <div class="situacao__linha">
        <span class="situacao__icone" aria-hidden="true"><i class="fas" [ngClass]="situacao.icone"></i></span>
        <div>
          <strong>{{ situacao.titulo }}</strong>
          <p>{{ situacao.texto }}</p>
        </div>
      </div>
      <ng-container *ngIf="podeChamar || podeAutorizar">
        <button type="button" class="primario largo" *ngIf="podeChamar" (click)="chameMia()" [disabled]="chamando || autorizando">
          <i class="fas" [ngClass]="chamando ? 'fa-spinner fa-spin' : 'fa-robot'" aria-hidden="true"></i>{{ chamando ? 'Chamando…' : 'Chamar a Mia para a conversa' }}
        </button>
        <button type="button" class="largo" *ngIf="podeAutorizar" (click)="autorize()" [disabled]="autorizando || chamando">
          <i class="fas" [ngClass]="autorizando ? 'fa-spinner fa-spin' : 'fa-user-check'" aria-hidden="true"></i>{{ autorizando ? 'Autorizando…' : 'Só autorizar' }}
        </button>
        <small class="nota" *ngIf="podeChamar">Chamar: a Mia manda a primeira mensagem agora, continuando de onde a conversa parou.<ng-container *ngIf="podeAutorizar"> Só autorizar: ela responde a partir da próxima mensagem do lead.</ng-container></small>
      </ng-container>
    </div>

    <p class="faixa faixa--erro" role="alert" *ngIf="erro">{{ erro }}</p>
    <p class="faixa faixa--ok" role="status" *ngIf="aviso"><i class="fas fa-check" aria-hidden="true"></i>{{ aviso }}</p>

    <ng-container *ngIf="dados.lead as lead">
      <h4 class="secao">Funil</h4>
      <div class="funil">
        <span class="selo selo--etapa selo--{{ lead.etapa | lowercase }}">{{ rotuloEtapa(lead.etapa) }}</span>
        <span class="selo" *ngIf="dados.atendimento">{{ dados.atendimento.rotuloFase }}</span>
        <span class="selo selo--atencao" *ngIf="dados.atendimento?.encaminhamento">
          {{ dados.atendimento.encaminhamento.status === 'OPT_OUT' ? 'Pediu para parar' : 'Pediu a equipe' }}
        </span>
      </div>

      <dl class="dados" *ngIf="dados.atendimento?.ficha as ficha">
        <div *ngIf="ficha.segmento"><dt>Segmento</dt><dd>{{ ficha.segmento }}</dd></div>
        <div *ngIf="ficha.ferramentaAtual"><dt>Usa hoje</dt><dd>{{ ficha.ferramentaAtual }}</dd></div>
        <div *ngIf="ficha.problema"><dt>Problema</dt><dd>{{ ficha.problema }}</dd></div>
        <div *ngIf="ficha.objecao"><dt>Objeção</dt><dd>{{ ficha.objecao }}</dd></div>
        <div *ngIf="ficha.proximoPasso"><dt>Próximo passo</dt><dd>{{ ficha.proximoPasso }}</dd></div>
      </dl>

      <h4 class="secao">Dados do lead</h4>
      <dl class="dados">
        <div *ngIf="lead.nome"><dt>Nome</dt><dd>{{ lead.nome }}</dd></div>
        <div *ngIf="lead.empresa"><dt>Empresa</dt><dd>{{ lead.empresa }}</dd></div>
        <div *ngIf="lead.instagram"><dt>Instagram</dt><dd><a *ngIf="linkInstagram; else soTexto" [href]="linkInstagram" target="_blank" rel="noopener">{{ lead.instagram }}</a><ng-template #soTexto>{{ lead.instagram }}</ng-template></dd></div>
        <div *ngIf="lead.email"><dt>E-mail</dt><dd>{{ lead.email }}</dd></div>
        <div *ngIf="lead.temComputador !== null"><dt>Computador</dt><dd>{{ lead.temComputador ? 'Sim' : 'Não' }}</dd></div>
        <div><dt>Canal</dt><dd>{{ lead.canal || 'site' }}</dd></div>
        <div><dt>Origem</dt><dd>{{ rotuloOrigem(lead.origem) }}</dd></div>
        <div><dt>Registrado</dt><dd>{{ lead.ultimoFormularioEm | date:'dd/MM HH:mm' }}</dd></div>
        <div *ngIf="lead.primeiraMensagemEm"><dt>1ª mensagem</dt><dd>{{ lead.primeiraMensagemEm | date:'dd/MM HH:mm' }}</dd></div>
        <div *ngIf="lead.testeCriadoEm"><dt>Teste criado</dt><dd>{{ lead.testeCriadoEm | date:'dd/MM HH:mm' }}</dd></div>
      </dl>

      <div class="acoes">
        <button type="button" (click)="mova('CLIENTE')" [disabled]="movendo || lead.etapa === 'CLIENTE'"><i class="fas fa-trophy" aria-hidden="true"></i>Cliente</button>
        <button type="button" class="perigo" (click)="mova('PERDIDO')" [disabled]="movendo || lead.etapa === 'PERDIDO'"><i class="fas fa-times" aria-hidden="true"></i>Perdido</button>
        <a class="botao botao--link" [href]="linkKanban" target="_blank" rel="noopener">Ver no kanban<i class="fas fa-external-link-alt" aria-hidden="true"></i></a>
      </div>
      <div class="acoes acoes--futuras">
        <button type="button" disabled title="Disponível na próxima etapa"><i class="fas fa-hand-paper" aria-hidden="true"></i>Assumir</button>
        <button type="button" disabled title="Disponível na próxima etapa"><i class="fas fa-robot" aria-hidden="true"></i>Devolver para a Mia</button>
        <small>Assumir e devolver chegam na próxima etapa.</small>
      </div>
    </ng-container>
  </ng-container>
</section>
